// extracted by mini-css-extract-plugin
export default {"expiredContainer":"ExpiredApplication_expiredContainer"};